module.exports = __webpack_public_path__ + "img/cargo.798b466.webp";